export enum PageTypeEnum {
	SIMPLE = 'simple',
	LANDING = 'landing',
	HOME = 'home',
}
